import React, { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

// Renders a PDF inside our own app shell instead of letting the browser hand
// the tab over to its native PDF viewer - that native viewer ignores the
// site favicon entirely, so opening a raw .pdf URL always shows the
// browser's own document icon. Embedding it in an iframe on an in-app route
// keeps the NEXORAH tab icon and title.
export default function PdfViewer() {
    const [searchParams] = useSearchParams();
    const file = searchParams.get('file') || '';
    const name = searchParams.get('name') || 'Document';

    const src = useMemo(() => (file ? encodeURI(file) : ''), [file]);

    const styles = {
        page: { display: 'flex', flexDirection: 'column', height: '100vh', background: '#ECF2FE' },
        header: {
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            padding: '14px 24px', background: '#0A2540', color: '#fff', flexShrink: 0,
        },
        title: { fontWeight: 600, fontSize: '15px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
        actions: { display: 'flex', alignItems: 'center', gap: '16px', flexShrink: 0 },
        download: { color: '#fff', fontSize: '14px', textDecoration: 'none' },
        empty: { padding: '60px 20px', textAlign: 'center', color: '#5A6A85', fontSize: '15px' },
        frame: { flex: 1, border: 'none', width: '100%' },
    };

    return (
        <div style={styles.page}>
            <div style={styles.header}>
                <span style={styles.title}>{name}</span>
                <div style={styles.actions}>
                    {src && <a href={src} download style={styles.download}>Download</a>}
                </div>
            </div>
            {src ? (
                <iframe src={src} title={name} style={styles.frame} />
            ) : (
                <div style={styles.empty}>No document was specified.</div>
            )}
        </div>
    );
}
